import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetRelationTypeDetailDocument,
  type GetRelationTypeDetailQuery,
  type GetRelationTypeDetailQueryVariables,
} from "~/features/admin/relationTypes/gqls";
import { useTenant } from "~/features/tenant/context";

/**
 * Loads a single relation type by id (tenant-scoped, V1 parity). Used by both
 * the Peek side panel and the full-page detail route.
 */
export function useRelationTypeDetail(relationTypeId: string) {
  const { tenantId } = useTenant();
  if (!tenantId) {
    throw new Error("Tenant ID is required");
  }

  return useSuspenseQuery<GetRelationTypeDetailQuery, GetRelationTypeDetailQueryVariables>(
    GetRelationTypeDetailDocument,
    { variables: { tenantId, relationTypeId } },
  );
}
